
import ClubProfile from '~/components/molecules/clubs/ClubProfile.vue'
import { getMessageFromErrorResponse } from '~/utils/data'

export default {
  emits: ['submit'],

  components: { ClubProfile },

  props: {
    action: {
      type: Function,
      default: null,
    },

    club: {
      type: Object,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    joinLabel: {
      type: String,
      default: 'phrase.join',
    },
  },

  data() {
    return {
      submitting: false,
    }
  },

  methods: {
    async submit() {
      this.submitting = true

      try {
        if (this.action) {
          await this.action()
        } else {
          await this.requestJoinClub()
        }
      } finally {
        this.submitting = false
      }
    },

    /**
     * Send a request to join a club.
     */
    async requestJoinClub() {
      try {
        const result = await this.$store.dispatch('clubs/joinClub', {
          clubId: this.club.id,
          playerId: this.$auth.user.id,
        })

        const updatedClub = {
          ...this.club,
          club_grant_admin_request: result,
        }

        /**
         * Store the new club.
         * Don't fetch it from the server because the user admin rights are not yet validated.
         */
        this.$store.commit('clubs/addClubToList', updatedClub)

        this.$notify({
          message: this.$tc('notification.club.join', 1, [updatedClub.name]),
          type: 'success',
        })

        this.$emit('submit', updatedClub)
      } catch (error) {
        const message = getMessageFromErrorResponse(error, {
          409: 'error.club.cannot_resend_request',
        })

        this.$notify({ message, type: 'error' })
      }
    },
  },
}
